/* eslint-disable no-console */
/* eslint-enable no-console */

// Check if mobile
const isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

const handleGesture = (item) => {
    if (touchendX < touchstartX) {
        item.querySelector('.card').style.left = `${item.querySelector('.card').style.left + touchendX}px`;
    }

    if (touchendX > touchstartX) {
        item.querySelector('.card').style.left = `${touchendX + touchstartX}px`;
    }

}

// Get all CARDS
const cards = document.querySelectorAll('.wp-block-ds-citeocom-section-slider-eco-conception');
if (cards.length > 0) {
    cards.forEach((value) => {
        let cardWrapper = value.querySelector('.cards-wrapper');
        const card = value.querySelector('.card');
        const isPrev = value.querySelector('.isLeft');
        const isNext = value.querySelector('.isRight');

        if (card) {
            if (isMobile.any()) {
                if (isPrev && isNext) {
                    isPrev.addEventListener('click', () => {
                        const cardWidth = card.clientWidth;
                        cardWrapper.scrollLeft -= cardWidth;
                    });
                    isNext.addEventListener('click', () => {
                        const cardWidth = card.clientWidth;
                        cardWrapper.scrollLeft += cardWidth;
                    });
                }
            } else {
                if (isPrev && isNext) {
                    isPrev.addEventListener('click', () => {
                        const cardWidth = card.clientWidth;
                        cardWrapper.scrollLeft -= cardWidth + (cardWidth / 2);
                    });
                    isNext.addEventListener('click', () => {
                        const cardWidth = card.clientWidth;
                        cardWrapper.scrollLeft += cardWidth + (cardWidth / 2);
                    });
                }
            }
        }
    });
}
